import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "form-avatar"
}
const _hoisted_2 = { class: "documents" }
const _hoisted_3 = { class: "flex flex-row gap-4" }
const _hoisted_4 = {
  key: 1,
  class: "flex flex-row gap-4"
}
const _hoisted_5 = { class: "flex flex-row gap-4" }

import { computed, ref, watchEffect } from "vue";
import { useI18n } from "vue-i18n";

import { maskCPF, maskCNPJ } from "@/common/utils/mask";

import {
  baseAvatar,
  baseInput,
  baseSelect,
  baseTextarea,
} from "@/common/components";

import type { CompanyPayloadType } from "@/common/types/company";


export default /*@__PURE__*/_defineComponent({
  __name: 'company',
  props: {
    data: {},
    avatar: {},
    title: {},
    width: { default: "100%" },
    showAvatar: { type: Boolean, default: false }
  },
  emits: ["update-data", "avatar-add", "avatar-del"],
  setup(__props: any, { emit: __emit }) {

const { t, tm } = useI18n();

const emit = __emit;

const props = __props;

const defaultData = {
  description: null,
  document_number: "",
  document_type: "",
  document_name: "",
  fantasy_name: "",
  name: "",
  cnae: "",
  danger: "1",
  number_of_employee: "",
};

const documentTypes = computed(() => [
  {
    option: t("common.labels.cpf"),
    value: "cpf",
  },
  {
    option: t("common.labels.cnpj"),
    value: "cnpj",
  },
  {
    option: t("common.labels.other"),
    value: "other",
  },
]);

const employeesOptions = computed(() =>
  Object.entries(
    tm("options.number_of_employees") as Record<string, string>
  ).map(([value, option]) => ({
    option,
    value,
  }))
);

const dangerOptions = computed(() =>
  Array.from({ length: 10 }, (_, value) => ({
    option: String(value + 1),
    value: String(value + 1),
  }))
);

const payload = ref<CompanyPayloadType>({ ...defaultData });

function update() {
  emit("update-data", payload.value);
}

function documentMask(value: any) {
  if (payload.value.document_type === "cpf") return maskCPF(value);

  if (payload.value.document_type === "cnpj") return maskCNPJ(value);

  return value;
}

function changeType(type: any) {
  payload.value.document_name = type;
  payload.value.document_number = documentMask(payload.value.document_number);

  if (type === "other") payload.value.document_name = "";

  update();
}

function changeAvatar(avatar: string) {
  emit("avatar-add", avatar);
}

function delAvatar() {
  emit("avatar-del");
}

watchEffect(() => {
  if (props.data) {
    const {
      cnae,
      danger,
      description,
      document_number,
      document_type,
      document_name,
      fantasy_name,
      name,
      number_of_employee,
    } = {
      ...props.data,
    };

    payload.value = {
      cnae,
      danger,
      description,
      document_number,
      document_type,
      document_name,
      fantasy_name,
      name,
      number_of_employee,
    };
  } else {
    payload.value = { ...defaultData };
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: "form-content",
    style: _normalizeStyle({ width: __props.width })
  }, [
    _createElementVNode("form", null, [
      (__props.showAvatar)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_unref(baseAvatar), {
              url: props.avatar,
              "is-edit": true,
              onChange: changeAvatar,
              onDel: _cache[0] || (_cache[0] = ($event: any) => (delAvatar()))
            }, null, 8, ["url"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_unref(baseInput), {
        modelValue: payload.value.name,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((payload.value.name) = $event)),
        value: payload.value.name,
        placeholder: _unref(t)('common.placeholders.name'),
        onInput: _cache[2] || (_cache[2] = ($event: any) => (update()))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.corporate_reason")) + " *", 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "placeholder"]),
      _createVNode(_unref(baseInput), {
        modelValue: payload.value.fantasy_name,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((payload.value.fantasy_name) = $event)),
        value: payload.value.fantasy_name,
        onInput: _cache[4] || (_cache[4] = ($event: any) => (update()))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.fantasy_name")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value"]),
      _createElementVNode("div", _hoisted_2, [
        (payload.value.document_type === 'other')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_unref(baseSelect), {
                  class: "flex-2",
                  modelValue: payload.value.document_type,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((payload.value.document_type) = $event)),
                  value: payload.value.document_type,
                  options: documentTypes.value,
                  onChange: changeType
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("common.labels.document_type")) + " * ", 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "value", "options"]),
                _createVNode(_unref(baseInput), {
                  class: "flex-3",
                  modelValue: payload.value.document_name,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((payload.value.document_name) = $event)),
                  value: payload.value.document_name,
                  placeholder: _unref(t)('common.placeholders.describe'),
                  onInput: _cache[7] || (_cache[7] = ($event: any) => (update()))
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("common.labels.name")) + " *", 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "value", "placeholder"])
              ]),
              _createVNode(_unref(baseInput), {
                class: "flex-4",
                modelValue: payload.value.document_number,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((payload.value.document_number) = $event)),
                value: payload.value.document_number,
                placeholder: _unref(t)('common.labels.number'),
                mask: documentMask,
                onInput: _cache[9] || (_cache[9] = ($event: any) => (update()))
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("common.labels.number")) + " *", 1)
                ]),
                _: 1
              }, 8, ["modelValue", "value", "placeholder"])
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_unref(baseSelect), {
                class: "flex-2",
                modelValue: payload.value.document_type,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((payload.value.document_type) = $event)),
                value: payload.value.document_type,
                options: documentTypes.value,
                onChange: changeType
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("common.labels.document_type")) + " * ", 1)
                ]),
                _: 1
              }, 8, ["modelValue", "value", "options"]),
              _createVNode(_unref(baseInput), {
                class: "flex-3",
                modelValue: payload.value.document_number,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((payload.value.document_number) = $event)),
                value: payload.value.document_number,
                placeholder: _unref(t)('common.labels.number'),
                mask: documentMask,
                onInput: _cache[12] || (_cache[12] = ($event: any) => (update()))
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("common.labels.number")) + " *", 1)
                ]),
                _: 1
              }, 8, ["modelValue", "value", "placeholder"])
            ]))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_unref(baseInput), {
          modelValue: payload.value.cnae,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((payload.value.cnae) = $event)),
          value: payload.value.cnae,
          onInput: _cache[14] || (_cache[14] = ($event: any) => (update()))
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)("common.labels.cnae")), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "value"]),
        _createVNode(_unref(baseSelect), {
          modelValue: payload.value.danger,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((payload.value.danger) = $event)),
          value: payload.value.danger,
          options: dangerOptions.value,
          onChange: _cache[16] || (_cache[16] = ($event: any) => (update()))
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)("analysis.labels.risk_degree")), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "value", "options"]),
        _createVNode(_unref(baseSelect), {
          modelValue: payload.value.number_of_employee,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((payload.value.number_of_employee) = $event)),
          value: payload.value.number_of_employee,
          options: employeesOptions.value,
          onChange: _cache[18] || (_cache[18] = ($event: any) => (update()))
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)("common.labels.number_of_employee")), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "value", "options"])
      ]),
      _createVNode(_unref(baseTextarea), {
        modelValue: payload.value.description,
        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((payload.value.description) = $event)),
        value: payload.value.description,
        placeholder: _unref(t)('common.placeholders.describe'),
        onInput: _cache[20] || (_cache[20] = ($event: any) => (update()))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.description")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "placeholder"])
    ])
  ], 4))
}
}

})